export default __webpack_public_path__ + "static/fjnew-5e0de0528f7f95216ca7098bf50c820f.png";